import {View} from 'MWC';
import tpl from '../templates/accordion-item.jsx';

export default class extends View {
    template = tpl;

    constructor(props) {
        super(props);

        this.state = {
            ui: this.uiStates.INITIAL,
            isOpen: false
        };
    }

    toggleIsOpen = () => {
        this.setState(prev => ({isOpen: !prev.isOpen}));
    };
}
